module.exports = __webpack_public_path__ + "img/5-2.247583d4.jpg";